import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Arrange, Avatar, Typography } from "@aviary";
import FullscriptLogoSvg from "@shared/assets/logo/fullscript-logo-green-leaf-pigeon-text.svg";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./PatientInfoBlock.styles";

interface Props {
  pracName: string;
  pracAvatar?: string;
  children: ReactNode;
}

const PatientInfoBlock: FC<Props> = ({ children, pracName, pracAvatar }) => {
  const { t } = useTranslation();
  return (
    <Arrange isVertical justify="center" alignment="center" css={styles.fullHeight}>
      <FullscriptLogoSvg css={styles.svgContainer} />
      {pracAvatar && (
        <Avatar
          image={pracAvatar}
          label={t(l.patientRxAuth.storeLandingPages.leftColumn.pracAvatar, {
            pracName,
            interpolation: { escapeValue: false },
          })}
          size="large"
        />
      )}
      <Typography type="h4">
        {t(l.patientRxAuth.storeLandingPages.leftColumn.tips, {
          pracName,
          interpolation: { escapeValue: false },
        })}
      </Typography>
      {children}
    </Arrange>
  );
};

export { PatientInfoBlock };
